import { Switch } from 'react-router-dom';

import CreateOrder from 'pages/Private/Contigo/CreateOrder';
import FulfillOrder from 'pages/Private/Contigo/FulfillOrder';
import InvoiceOrder from 'pages/Private/Contigo/InvoiceOrder';
import OrderDetails from 'pages/Private/Contigo/OrderDetails';
import OrdersList from 'pages/Private/Contigo/OrdersList';
import Reports from 'pages/Private/Contigo/Reports';
import { Route } from 'routes/Route';

export const ContigoRoutes = () => {
  return (
    <Switch>
      <Route isPrivate exact path='/contigo/reports' component={Reports} />
      <Route isPrivate exact path='/contigo/orders' component={OrdersList} />
      <Route isPrivate exact path='/contigo/orders/new' component={CreateOrder} />
      <Route isPrivate exact path='/contigo/orders/:orderId/edit' component={CreateOrder} />
      <Route isPrivate exact path='/contigo/orders/:orderId' component={OrderDetails} />
      <Route isPrivate exact path='/contigo/orders/:orderId/fulfill' component={FulfillOrder} />
      <Route isPrivate exact path='/contigo/invoice' component={InvoiceOrder} />
    </Switch>
  );
};
